import React from 'react';
import {tid} from '../../../../../testUtils';
import SideBarButtonItem from '../../../../layout/common/SideBarButtonItem';
import {SUBMODEL_ACTION_MENU_IDS} from '../../../../../test/types';
import {ScenarioActionProps} from '../../../actionMenuTypes';
import useScenarioSupersedeSideBarModal from './useScenarioSupersedeSideBarModal';
import {canSupersedeInstance} from '../../../../../permissions/usePermissions';
import {Error16} from '@carbon/icons-react';

const ScenarioSupersedeActionMenuButton: React.FC<Partial<ScenarioActionProps>> = (props) => {
  const {ModalComponent, openModal} = useScenarioSupersedeSideBarModal(props);

  return (
    <>
      <SideBarButtonItem
        {...tid(SUBMODEL_ACTION_MENU_IDS.SCENARIO_SUPERSEDE)}
        permission={canSupersedeInstance(props.model, props.subModel, props.scenario)}
        onClick={openModal}
        icon={<Error16 />}
        text="Supersede"
      />
      {ModalComponent}
    </>
  );
};

export default ScenarioSupersedeActionMenuButton;
